type HomeSectionTitleProps = {
  title: string;
  subtitle: string;
  dividerClassName?: string;
};

const HomeSectionTitle = ({ title, subtitle, dividerClassName = "mb-6 sm:mb-8" }: HomeSectionTitleProps) => (
  <>
    <h2 className="text-center text-2xl sm:text-3xl font-bold sm:font-extrabold text-neutral-900 mb-2">{title}</h2>
    <p className="mb-4 text-center text-sm sm:text-base font-medium text-neutral-900">{subtitle}</p>
    <div className={`mx-auto h-1 w-10 bg-primary-600 ${dividerClassName}`} />
  </>
);

export default HomeSectionTitle;
